import * as api from '../../../clients/api';

import {Action} from '@ngrx/store';

export const GET_LOGIN_CHECK = '[ApiModul] GetLoginCheck laden';
export const GET_LOGIN_CHECK_AUSFUEHREN = '[ApiModul] GetLoginCheck ausführen';
export const GET_LOGIN_CHECK_ERFOLGREICH = '[ApiModul] GetLoginCheck laden erfolgreich';
export const GET_LOGIN_CHECK_FEHLER = '[ApiModul] GetLoginCheck Ladefehler';
export const GET_LOGIN_CHECK_NICHT_AUSGEFUEHRT = '[ApiModul] GetLoginCheck nicht ausgeführt (evtl. Offline)';


export class GetLoginCheckAction implements Action {
    readonly type = GET_LOGIN_CHECK;
        constructor( public email:string , public optPayload: any = null) {}
    }
export class GetLoginCheckAusfuehrenAction implements Action {
    readonly type = GET_LOGIN_CHECK_AUSFUEHREN;
        constructor( public email:string , public optPayload: any = null) {}
    }
export class GetLoginCheckErfolgreichAction implements Action {
    readonly type = GET_LOGIN_CHECK_ERFOLGREICH;
        constructor(public payload: api.LoginCheckResult,  public email:string , public optPayload: any = null) {}
    }
export class GetLoginCheckFehlerAction implements Action {
    readonly type = GET_LOGIN_CHECK_FEHLER;
        constructor(public payload: any,  public email:string , public optPayload: any = null) {}
    }
export class GetLoginCheckNichtAusgefuehrtAction implements Action {
    readonly type = GET_LOGIN_CHECK_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type ApiQueryLoginCheckActions =
    GetLoginCheckAction
    | GetLoginCheckAusfuehrenAction
    | GetLoginCheckErfolgreichAction
    | GetLoginCheckFehlerAction
    | GetLoginCheckNichtAusgefuehrtAction
    ;
